<template>
  <div>
    <el-dialog title="选择模板" :visible="true" width="1200px" @close="dialogClose">
      <!-- 导航切换 -->
      <div class="activeEdit_bottom">
        <div class="template">
          <div style="width: 82px;padding-top: 5px;">模板类型：</div>
          <div class="template-nav">
            <div
              class="template-wz pointer"
              v-for="(item, index) in navList"
              :key="item.id"
              @click="handleNav(item, index)"
              :class="{ activeTem: tabActive == index }"
              v-show="item.isVisible"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <!-- m模板图 -->
        <div class="templateBox">
          <!-- 定制 -->
          <div class="temImg" v-if="navItem.id != '100'">
            <div class="temImg_content" @click="handleOpen()" style="border: 1px solid #D4E2FF;">
              <div class="temImg_content_img temImg_dz">
                <div class="temImg_dz_center">
                  <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                  <span>品牌定制</span>
                </div>
              </div>
              <div class="temImg_content_wz" style="background: #EAF1FF;"></div>
            </div>
            <!-- hover -->
            <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
              <div class="temImg_content_bgshadow_codeDZ">
                <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
              </div>
            </div>
          </div>
          <!-- 自定义上传 -->
          <div class="temImg" v-else>
                <div class="temImg_content pointer" @click="visibleUpload = true" style="border: 1px solid rgba(123,97,255,0.15);">
                  <div class="temImg_content_img temImg_dz">
                    <div class="temImg_dz_center">
                      <!-- <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" /> -->
                      <span>上传图片</span>
                    </div>
                  </div>
                  <div class="temImg_content_wz" style="background: rgba(123,97,255,0.05);"></div>
                </div>
              </div>
          <!-- 模板 -->
          <div class="temImg" v-for="item in giftList" :key="item.id">
            <div class="temImg_content">
              <div class="temImg_content_img">
                <img style="width:100%;max-height: 380px;" v-if="activityDataID == 13" :src="item.templateUrl" alt="" />
                <img style="width:100%;max-height: 380px;" v-if="activityDataID == 14" :src="item.templateExampleUrl" alt="" />
                <img style="width:100%;max-height: 380px;" v-if="activityDataID == 15" :src="item.templateExampleUrl" alt="" />
                <img v-if="item.expirationType" class="temImg_content_img_free" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/free.svg" alt="" srcset="" />
                <div v-if="item.expirationType" class="temImg_content_img_time">倒计时：{{ item.days }}</div>
              </div>
              <div class="temImg_content_wz">
                <span class="temImg_title">{{ item.templateName }}</span>
                <span class="temImg_desc">模板ID：{{ item.id }}</span>
              </div>
            </div>
            <!-- hover -->
            <div class="temImg_content_bgshadow">
              <div
                class="temImg_content_bgshadow_code qrCodeIMG"
                id="qrCodeIMG1"
                ref="qrCodeIMG1"
                :style="{ marginTop: item.prizeType != '[]' ? '80px' : '' }"
              ></div>
              <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
              <div class="temImg_content_bgshadow_jx" v-if="item.prizeType && item.prizeType != '[]'">
                <div>奖项：最多支持{{ item.awardNumLimit || item.prizeType.split(",").length }}个奖品</div>
                <div>
                  （{{
                    item.prizeType
                      .replace("1", "店铺积分")
                      .replace("2", "京豆")
                      .replace("3", "京券")
                      .replace("4", "东券")
                      .replace(/,/g, "、")
                  }}）
                </div>
              </div>
              <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item)">使用此模板</div>
            </div>
          </div>
        </div>
        <br />
        <!-- 分页 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageData.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          style="text-align: right;margin-top: 20px;"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <uploadPopup v-if="visibleUpload" :visible.sync="visibleUpload" @handleSave="handleSave" />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import uploadPopup from "./uploadPopup.vue";
import {
  getPersonLabelList,
  createShopGift,
  getGiftBagTemplate,
  getGiftBagList,
  giftBagEide,
  editShopGift,
  getValidActivity,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { giftBagTemplate, templateDelete } from "@/api/jhk/public.js";
export default {
  components: {
    uploadPopup
  },
  props: {
    // giftList: {
    //   type: Array,
    //   default: [],
    // },
    activityDataID: {},
  },
  data() {
    return {
      visibleUpload: false,
      giftPopup: false,
      navList: [],
      navItem:{},
      tabActive: 0,
      giftList: [],
      pageData: {
        size: 10,
        current: 1,
        total: 0,
      },
    };
  },
  async created() {
    console.log(this.activityDataID);
    const num = this.activityDataID == 13 ? 0 : this.activityDataID == 14 ? 1 : 2;
    const GiftBag = await getGiftBagList(num);
    this.navList = [
      {
        id: "",
        isVisible: true,
        title: "全部",
      },
      ...GiftBag.data,
    ];
    this.navItem = this.navList[0];
    this.getPolite();
  },
  methods: {
    // 自定义保存
    handleSave(obj) {
      giftBagTemplate({ ...obj, templateDirId: this.navItem.id}).then((res) => {
        if (res.code == 1) {
          this.visibleUpload = false;
          this.getPolite();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.pageData.size = val;
      this.getPolite();
    },
    handleCurrentChange(val) {
      this.pageData.current = val;
      this.getPolite();
    },
    async getPolite() {
      // 开卡礼包版本
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        dirId: this.navItem.id,
        giftType: this.activityDataID == 13 ? 0 : this.activityDataID == 14 ? 1 : 2,
      };
      const { data } = await getGiftBagTemplate(params);
      this.giftList = data.records.map((item) => ({
        ...item,
        days: item.expirationType == 1 ? this.getDaysBetween(item.expirationStartDate, item.expirationEndDate) : "",
      }));
      // if (this.activityDataID == 13) {
      //   this.giftList = giftList.filter((i) => i.giftType == 0);
      // }
      // if (this.activityDataID == 14) {
      //   this.giftList = giftList.filter((i) => i.giftType == 1);
      // }
      // if (this.activityDataID == 15) {
      //   this.giftList = giftList.filter((i) => i.giftType == 2);
      // }
      this.pageData.total = data.total * 1;

      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    nextStepKai(item) {
      this.$emit("handleChoice", item);
    },
    dialogClose() {
      this.$emit("handleChoice");
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    getCodeIMG() {
      if (this.activityDataID != 15) {
        const codeImg = document.querySelectorAll(".qrCodeIMG");
        for (let index = 0; index < codeImg.length; index++) {
          const elementbox = codeImg[index];
          elementbox.innerHTML = "";
        }
        // const url = this.activityDataID == 14 ? "http://index.yeionsms.com/yidongd/shop.html" : "http://index.yeionsms.com/yidongd/index.html";
        // const url = this.activityDataID == 14 ? "http://index.yeionsms.com/yidongd/shop.html" : "http://index.yeionsms.com/yidongd/index.html";
        const url = this.activityDataID == 14 ? "http://yq-hd-rc.isvjcloud.com/shop.html" : "http://index.yeionsms.com/yidongd/index.html";
        // const codeImg = this.$refs[queryIdIMG];
        for (let index = 0; index < codeImg.length; index++) {
          const element = codeImg[index];
          new QRCode(element, {
            width: 140, // 设置宽度，单位像素
            height: 140, // 设置高度，单位像素
            // text: url, // 设置二维码内容或跳转地址
            text:
              this.activityDataID == 13
                ? `${url}?image=${this.giftList[index].templateUrl}`
                : `${url}?image=${this.giftList[index].templateExampleUrl}`,
          });
        }
      } else {
        const codeImg = document.querySelectorAll(".qrCodeIMG");
        for (let index = 0; index < codeImg.length; index++) {
          const elementbox = codeImg[index];
          elementbox.innerHTML = "";
        }
        const url = "http://yq-hd-rc.isvjcloud.com/shop.html";
        // const codeImg = this.$refs[queryIdIMG];
        for (let index = 0; index < codeImg.length; index++) {
          const element = codeImg[index];
          new QRCode(element, {
            width: 140, // 设置宽度，单位像素
            height: 140, // 设置高度，单位像素
            // text: url, // 设置二维码内容或跳转地址
            text: `${url}?image=${this.giftList[index].templateExampleUrl}`,
          });
        }
      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  margin-top: 9vh !important;
}
.activeEdit_bottom {
  max-height: 73vh;
  overflow-y: auto;
}
.navTab {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
  height: 50px;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #f6f6f6;
  span {
    height: 50px;
    line-height: 50px;
    position: relative;
    padding: 0 11px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .active {
    color: #fe4d45;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80%;
      height: 2px;
      background-color: #fe4d45;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
</style>
